module.exports = __webpack_public_path__ + "static/media/event-services-img2.01462993.jpg";